//@ts-nocheck
import { getConfig } from "../config/config";
import { convertTime12To24, getMaxDate } from "../helpers";
import moment from "moment";
const { APP_BASE_APIHUB_API_URL } = getConfig();
export const papiApi = async (symbolInfo, indexFundsSymbols, indexSymbols) => {
    const description = symbolInfo.description;
    const pattern = /([A-Z0-9&-]+(?:\s+[A-Z0-9&-]+)*)\s+(\d+\s+[A-Za-z]+\s+\d{4})/;
    const matches = description.match(pattern);
    const symbol = matches[1];
    let expiryDate = matches[2];
    expiryDate = expiryDate.replace(/ /g, "-");
    expiryDate = expiryDate.replace(/,/g, "");
    let fullString = symbolInfo.ticker;
    let parts = fullString.split("/");
    let firstPart = parts[0];
    let paramExch = firstPart.split(":");
    let exchParam = paramExch[0];
    var futType = "futstk";
    if (indexFundsSymbols.includes(indexSymbols.toUpperCase()) ||
        indexFundsSymbols.includes(indexSymbols.toLowerCase())) {
        futType = "futidx";
    }
    let derType = futType;
    if (symbolInfo.type === "futures" || symbolInfo.type === "FUTURES")
        derType = futType;
    //debugger;
    try {
        let url = ``;
        if (exchParam.toUpperCase() === "NSE") {
            url = `${APP_BASE_APIHUB_API_URL}atlas-req1-rt/datamart/Derivative/Derivative.svc/Get-Derivatives-Quotes/GQ/${expiryDate}/${derType}/${symbol}/all/all/all/desc/1/10?responsetype=json`;
        }
        else {
            url = `${APP_BASE_APIHUB_API_URL}atlas-req1-rt/datamart/Derivative/Derivative.svc/BSEGetDerivativesQuotes/GQ/${expiryDate}/${derType}/${symbol}/all/all/all/desc/1/10?responsetype=json`;
        }
        let response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });
        // if (!response.ok) {
        //   throw new Error(`API call failed with status: ${response.status}`);
        // }
        let data = await response.json();
        let dataToday;
        if (exchParam.toUpperCase() === "NSE") {
            dataToday = data.response.data.getexpirydatelist.getexpirydate[0];
        }
        else {
            dataToday =
                data.response.data.FNOStockIdentifierList.FNOStockIdentifier;
        }
        return dataToday;
    }
    catch (e) {
        // loggly_util.logAdvancedMessage(e, {
        //   error: e.message,
        //   APIURL: `https://atlas.5paisa.com/datamart/Derivative/Derivative.svc/Get-Derivatives-Quotes/GQ/${expiryDate}/${derType}/${symbol}/all/all/all/desc/1/10?responsetype=json`,
        //   Windowurl: window.location.href,
        //   Token: JSON.parse(localStorage.TokenResponseTv).access_token,
        // });
    }
};
export const papiApiOptions = async (symbolInfo, indexFundsSymbols, indexSymbols) => {
    const description = symbolInfo.description;
    const pattern = /([A-Z0-9&-]+(?:\s+[A-Z0-9&-]+)*)\s+(\d+\s+[A-Za-z]+\s+\d{4})\s+(CE|PE)\s+(\d+(?:\.\d+)?)/;
    const matches = description.match(pattern);
    const symbol = matches[1];
    const optionType = matches[3];
    const strikePrice = matches[4];
    let expiryDate = matches[2];
    expiryDate = expiryDate.replace(/ /g, "-");
    expiryDate = expiryDate.replace(/,/g, "");
    let fullString = symbolInfo.ticker;
    let parts = fullString.split("/");
    let firstPart = parts[0];
    let paramExch = firstPart.split(":");
    let exchParam = paramExch[0];
    var otpType = "optstk";
    if (indexFundsSymbols.includes(indexSymbols.toUpperCase()) ||
        indexFundsSymbols.includes(indexSymbols.toLowerCase())) {
        otpType = "optidx";
    }
    let derType = otpType;
    let strk;
    if (symbolInfo.type === "options" || symbolInfo.type === "OPTIONS")
        derType = otpType;
    try {
        if (exchParam == "NSE" || exchParam == "nse") {
            var response = await fetch(`${APP_BASE_APIHUB_API_URL}atlas-req1-rt/datamart/Derivative/Derivative.svc/Get-Derivatives-Quotes/GQ/${expiryDate}/${otpType}/${symbol}/${optionType}/${strikePrice}/all/desc/1/10?responsetype=json`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            })
                .then((response) => response.json())
                .then((data) => {
                if (data.response.data.getexpirydatelist.recordcount > 0) {
                    dataToday =
                        data.response.data.getexpirydatelist.getexpirydate[0];
                }
            });
            return dataToday;
        }
        else {
            var response = await fetch(`${APP_BASE_APIHUB_API_URL}atlas-req1-rt/datamart/Derivative/Derivative.svc/BSEGetDerivativesQuotes/GQ/${expiryDate}/${otpType}/${symbol}/${optionType}/${strikePrice}/all/desc/1/10?responsetype=json`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            })
                .then((response) => response.json())
                .then((data) => {
                // dataToday = data.response.data.FNOStockIdentifierList.FNOStockIdentifier[0];
                if (data.response.data.FNOStockIdentifierList.recordcount > 0) {
                    dataToday =
                        data.response.data.FNOStockIdentifierList.FNOStockIdentifier;
                }
            });
            return dataToday;
        }
    }
    catch (e) {
        // loggly_util.logAdvancedMessage(e, {
        //   error: e.message,
        //   APIURL: `https://atlas.5paisa.com/datamart/Derivative/Derivative.svc/Get-Derivatives-Quotes/GQ/${expiryDate}/${derType}/${symbol}/${optionType}/${~~parseInt(
        //     strikePrice
        //   )}/all/desc/1/10?responsetype=json`,
        //   Windowurl: window.location.href,
        //   Token: JSON.parse(localStorage.TokenResponseTv).access_token,
        // });
    }
};
export const getTimeFromSymbolInfo = async (symbolInfo, bar, resolution, timeDiffAdj) => {
    function convertToEpochTime(dateString) {
        // Parse the date string using Moment.js with the specified format
        const momentObj = moment(dateString, "YYYY-MM-DD hh:mm:ss A");
        // Convert the Moment.js object to epoch time in milliseconds
        const epochTime = momentObj.valueOf();
        // Return the epoch time
        return epochTime;
    }
    function convertToEpochTimeCustom(dateString) {
        // Parse the date string using Moment.js with the specified format
        const momentObj = moment(dateString, "M/D/YYYY h:mm:ss A");
        // Convert the Moment.js object to epoch time in milliseconds
        const epochTime = momentObj.valueOf();
        // Return the epoch time
        return epochTime;
    }
    function convertToEpochCommodity(dateString) {
        // Parse the input date string
        let [datePart, timePart] = dateString.split(" ");
        let [year, month, day] = datePart.split("-").map(Number);
        // JavaScript months are 0-based, so subtract 1 from month
        let date = new Date(year, month - 1, day, 9, 0, 0, 0);
        return date.getTime();
    }
    let time;
    const isObject = typeof bar === "object" && !Array.isArray(bar);
    if (["C", "U"].includes(symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.exchType) || ["MCX", "M"].includes(symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.exchange)) {
        if ((symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.exchType) === "C" && resolution === "1M") {
            const maxDate = await getMaxDate(bar.TradeMonth).getTime();
            return maxDate;
        }
        else if ((symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.exchType) === "D" && resolution === "1M") {
            let correctedDateFormat = convertTime12To24(...bar.Date.split(" "));
            correctedDateFormat = correctedDateFormat.includes("T")
                ? correctedDateFormat.split("T")
                : correctedDateFormat.substring(0, 9);
            time = Math.floor(new Date(correctedDateFormat).getTime() + timeDiffAdj);
        }
        else if (["1D", "1W"].includes(resolution)) {
            if ((symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.exchange) === "MCX" || (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.exchange) === "M") {
                time = await convertToEpochCommodity((isObject ? bar.Date : bar[0]));
            }
            else {
                const tempDate = new Date((isObject ? bar.Date : bar[0]).replace(/-/g, "/"));
                const utcDate = new Date(tempDate - tempDate.getTimezoneOffset() * 60000);
                time = utcDate.toISOString();
            }
        }
        else {
            let correctedDateFormat = convertTime12To24(...(isObject ? bar.Date : bar[0]).split(" "));
            time = Math.floor(new Date(correctedDateFormat).getTime() + timeDiffAdj);
        }
    }
    else {
        time = isObject ? convertToEpochTimeCustom(bar.Date) : convertToEpochTime(bar[0]);
    }
    return time;
};
export const processFeed = async (feed, symbolInfo, resolution) => {
    let bars = [];
    for (const bar of feed) {
        const isObject = typeof bar === "object" && !Array.isArray(bar);
        const Open = isObject ? bar.Open : bar[1];
        const High = isObject ? bar.High : bar[2];
        const Low = isObject ? bar.Low : bar[3];
        const Close = isObject ? bar.Close : bar[4];
        const Volume = isObject ? bar.Volume : bar[5];
        const timeDiffAdj = ["1D", "1M", "1W"].includes(resolution) ? 19800000 : 0;
        const time = await getTimeFromSymbolInfo(symbolInfo, bar, resolution, timeDiffAdj);
        bars.push({
            time: new Date(time).setSeconds(0, 0),
            low: parseFloat(Low),
            high: parseFloat(High),
            open: parseFloat(Open),
            close: parseFloat(Close),
            volume: parseFloat(Volume),
        });
    }
    return bars;
};
export const getFormattedDate = async (dateObj) => dateObj.toJSON().split("T")[0];
export const getPeriod = (res) => {
    switch (res) {
        case "1H":
            return "60m";
        case "240":
            return "240m";
        case "1W":
        case "1M":
        case "1D":
            return "1d";
        default:
            return res + "m";
            ;
    }
};
